import React from 'react'

import {Button, Modal, ModalHeader, ModalActions} from '../UI/index.js'
import {formSpacing, FormStack, Input, MetricInput} from '../UI/forms/index.js'
import _ from 'lodash'

class CategoryModal extends React.Component {
    constructor(props) {
        super(props)
        this.initialState = {
            open: false,
            category: {
                name: '',
                price: '0,00',
                maxWeight: '0',
                length: 0,
                width: 0,
                height: 0,
                volume: 0,
                productCode: ''
            }
        }
        this.state = this.initialState
    }

    open(carrier, product, priceRuleIndex, categoryIndex, category) {
        this.setState({open: true, carrier, product, priceRuleIndex, categoryIndex, category})
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeMaxWeight(event) {
        if (/^$|^[-]{0,1}[0-9]{0,3}$|^[-]{0,1}[0-9]{0,3}[,][0-9]{0,3}$/.test(event.target.value)) {
            const {category} = this.state
            category.maxWeight = event.target.value
            this.setState({category})
        }
    }

    onChangeValue(event, path, parser) {
        const category = {...this.state.category}

        const value = typeof parser === 'function' ? parser(event.target.value) : event.target.value

        _.set(category, path, value)

        this.setState({category})
    }

    onRemove() {
        const {carrier, product, priceRuleIndex, categoryIndex} = this.state
        const {remove} = this.props
        remove(carrier, product, priceRuleIndex, categoryIndex)
        this.close()
    }

    onSubmit() {
        const {carrier, product, priceRuleIndex, categoryIndex, category} = this.state
        const {onChange} = this.props

        // Sort dimensions: length > width > height
        const [length, width, height] = [category.length || 0, category.width || 0, category.height || 0].sort((a, b) => b - a)

        category.length = length
        category.width = width
        category.height = height

        onChange(carrier, product, priceRuleIndex, categoryIndex, category)
        this.close()
    }

    render() {
        const {open, category, categoryIndex} = this.state

        return (
            <Modal style={{width: 400}} show={open} onClose={this.close.bind(this)}>
                <ModalHeader title='Wijzig categorie' onClose={this.close.bind(this)} style={{marginBottom: 0}} />

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Input
                        label='Naam'
                        value={category.name || ''}
                        placeholder={category.maxWeight ? `t/m ${category.maxWeight} kg` : `Cat ${categoryIndex + 1}`}
                        onChange={(event) => this.onChangeValue(event, 'name')}
                    />

                    <Input
                        label='Gewicht'
                        value={category.maxWeight}
                        onChange={this.onChangeMaxWeight.bind(this)}
                        append='kg'
                    />

                    <MetricInput
                        label='Lengte'
                        value={category.length}
                        divisionFactor={10}
                        onChange={(event) => this.onChangeValue(event, 'length', parseInt)}
                        append='cm'
                    />

                    <MetricInput
                        label='Breedte'
                        value={category.width}
                        divisionFactor={10}
                        onChange={(event) => this.onChangeValue(event, 'width', parseInt)}
                        append='cm'
                    />

                    <MetricInput
                        label='Hoogte'
                        value={category.height}
                        divisionFactor={10}
                        onChange={(event) => this.onChangeValue(event, 'height', parseInt)}
                        append='cm'
                    />

                    <MetricInput
                        label='Volume'
                        value={category.volume}
                        onChange={(event) => this.onChangeValue(event, 'volume', parseInt)}
                        append='L'
                    />
                </FormStack>

                <br />
                <ModalActions>
                    <Button variant='text' onClick={this.onRemove.bind(this)}>Verwijder</Button>
                    <Button variant='text' onClick={this.onSubmit.bind(this)}>Opslaan</Button>
                </ModalActions>
            </Modal>
        )
    }
}

export default CategoryModal
